module.exports = __webpack_public_path__ + "static/2-dd8e5543c44864fea6fa506ffc7d1a64.png";